import {createSelector} from 'reselect';

import type {NutshellState} from '../../../../store';

export const getSiteAnalyticsState = (state: NutshellState) => state.siteAnalytics;

// Analytics report
const getSiteAnalyticsReportState = createSelector(
    [getSiteAnalyticsState],
    (reportState) => reportState.siteAnalyticsReport
);

const getSiteAnalyticsChartState = createSelector(
    [getSiteAnalyticsReportState],
    (siteAnalyticsReport) => siteAnalyticsReport.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getSiteAnalyticsChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);
export const isChartTimedOut = createSelector(
    [getSiteAnalyticsChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = (state: NutshellState) => getSiteAnalyticsChartState(state).isErrored;

export const getCurrentReportChartData = createSelector(
    [getSiteAnalyticsChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);

export const getCurrentReportChartBucketWithValuesCount = createSelector(
    [getCurrentReportChartData],
    (chartData) =>
        chartData
            ? chartData.buckets.filter(
                  // Filter out buckets with a zero value for Views or Visitors
                  // @ts-expect-error
                  (bucket) =>
                      bucket.bucketData &&
                      bucket.bucketData.summary &&
                      bucket.bucketData.summary.segments &&
                      bucket.bucketData.summary.segments.Views &&
                      bucket.bucketData.summary.segments.Views.count &&
                      bucket.bucketData.summary.segments.Visitors &&
                      bucket.bucketData.summary.segments.Visitors.count
              ).length
            : 1
);

export const getSummaryStatsState = createSelector(
    [getSiteAnalyticsState],
    (reportState) => reportState.summaryStats
);

export const getSummaryStatsIsLoading = createSelector(
    [getSummaryStatsState],
    (summaryStatsState) => {
        return summaryStatsState.isLoading;
    }
);

export const getSiteAnalyticsTableData = createSelector(
    [getSiteAnalyticsReportState],
    (siteAnalyticsReport) => siteAnalyticsReport.tableData
);

export const getSiteAnalyticsTableDataHasError = createSelector(
    [getSiteAnalyticsTableData],
    (siteAnalyticsTableData) => siteAnalyticsTableData.hasError
);

export const getSiteAnalyticsTableRows = createSelector(
    [getSiteAnalyticsTableData],
    (siteAnalyticsTableData) => siteAnalyticsTableData.rows
);

export const getSiteAnalyticsTableTotals = createSelector(
    [getSiteAnalyticsTableData],
    (siteAnalyticsTableData) => siteAnalyticsTableData.totals
);

export const getSummaryStatsStats = createSelector([getSummaryStatsState], (summaryStatsState) => {
    return summaryStatsState.stats;
});
